import { useState } from "react";
import { C } from "./config.js";

/* Toast */
export function useToast() {
  const [toasts, setToasts] = useState([]);
  const show = (msg, type = "success") => {
    const id = Date.now();
    setToasts(t => [...t, { id, msg, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3000);
  };
  const ToastContainer = () => (
    <div style={{ position:"fixed", bottom:20, right:20, display:"flex", flexDirection:"column", gap:8, zIndex:9999 }}>
      {toasts.map(t => (
        <div key={t.id} style={{
          padding:"12px 18px", borderRadius:10, fontSize:13, fontWeight:600,
          display:"flex", alignItems:"center", gap:8, color:"#fff",
          background: t.type==="success" ? C.accent : t.type==="error" ? C.danger : "#b45309",
          boxShadow:"0 4px 20px rgba(92,124,206,.2)", animation:"adm-slideUp .2s ease",
        }}>
          {t.type==="success"?"✓":t.type==="error"?"✕":"⚠"} {t.msg}
        </div>
      ))}
    </div>
  );
  return { show, ToastContainer };
}

/* Modal */
export function Modal({ title, onClose, children, width = 480 }) {
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position:"fixed", inset:0, background:"rgba(10,28,24,.28)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:400, backdropFilter:"blur(5px)" }}>
      <div style={{ background:C.surface, borderRadius:18, width, maxWidth:"95vw", maxHeight:"90vh", overflowY:"auto", border:`1px solid ${C.border}`, boxShadow:"0 24px 70px rgba(26,35,126,.12)" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"18px 24px", borderBottom:`1px solid ${C.border}` }}>
          <span style={{ fontSize:16, fontWeight:700, color:C.t1 }}>{title}</span>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:22, cursor:"pointer", color:C.t3 }}>×</button>
        </div>
        <div style={{ padding:"22px 24px" }}>{children}</div>
      </div>
    </div>
  );
}

/* Field */
export function Field({ label, hint, children }) {
  return (
    <div style={{ marginBottom:16 }}>
      <label style={{ fontSize:12, fontWeight:700, color:C.t2, display:"block", marginBottom:6 }}>{label}</label>
      {children}
      {hint && <p style={{ fontSize:12, color:C.t3, marginTop:5 }}>{hint}</p>}
    </div>
  );
}

/* Button */
export function Btn({ children, onClick, variant = "primary", disabled, style: s }) {
  const base = {
    display:"inline-flex", alignItems:"center", gap:6, padding:"9px 16px",
    borderRadius:10, fontSize:13, fontWeight:600, cursor: disabled ? "not-allowed" : "pointer",
    border:"none", fontFamily:"inherit", transition:"all .15s", opacity: disabled ? .6 : 1,
  };
  const v = {
    primary: { background:C.accent,   color:"#fff",    boxShadow:"0 4px 12px rgba(92,124,206,.28)" },
    ghost:   { background:C.surface,  color:C.t2,      border:`1px solid ${C.border2}` },
    danger:  { background:C.dangerBg, color:C.danger,  border:"1px solid #fdc5ce" },
    sm:      { background:C.accentBg, color:C.accentTxt, padding:"6px 12px", fontSize:12 },
  };
  return <button onClick={onClick} disabled={disabled} style={{ ...base, ...v[variant], ...s }}>{children}</button>;
}
